import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './index.css';
import CookieConsent from "react-cookie-consent";

// Navbar & Footer
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// Terms & Policies
import TermsPage from "./pages/TermsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import PaymentTermsPage from "./pages/PaymentTermsPage";

// Sider
import Home from "./pages/Home";
import SchoolsAndClubsPage from "./pages/SchoolsAndClubsPage";
import Fornyemedlemmer from "./pages/Fornyemedlemmer";
import Login from "./pages/Login";
import SignupAcademy from "./pages/SignupAcademy";
import TrainingPage from "./pages/Gametime";
import Gamespage from "./pages/Gamespage";
import Omos from "./pages/Omos";
import AdminDashboard from "./pages/AdminDashboard";
import ProfileRouter from "./pages/ProfileRouter";
import WebGLMap from "./pages/WebGLMap";
import OpeningPrices from "./pages/OpeningPrices";

// ---------------- GA INITIALIZER ----------------
const GA_MEASUREMENT_ID = "G-E46V3NML1V";

const initGA = () => {
  if (!window.gtag) {
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;

    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    script.async = true;
    document.head.appendChild(script);

    gtag('js', new Date());
    gtag('config', GA_MEASUREMENT_ID, { anonymize_ip: true });
  }
};

function App() {
  return (
    <Router>
      <Navbar />

      {/* Cookie Consent midt på skærmen */}
      <CookieConsent
        location="none"
        buttonText="Accepter"
        declineButtonText="Afvis"
        cookieName="userConsent"
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          background: "#2B373B",
          color: "#fff",
          padding: "20px 30px",
          borderRadius: "10px",
          maxWidth: "90%",
          textAlign: "center",
          zIndex: 10000
        }}
        buttonStyle={{
          color: "#2B373B",
          background: "#fff",
          fontSize: "14px",
          margin: "10px"
        }}
        declineButtonStyle={{
          color: "#fff",
          background: "#888",
          fontSize: "14px",
          margin: "10px"
        }}
        enableDeclineButton
        expires={150}
        onAccept={() => initGA()}
      >
        Vi bruger cookies til statistik via Google Analytics. Læs vores{" "}
        <a href="/Privatlivspolitik" style={{ color: "#FFD700" }}>
          privatlivspolitik
        </a>.
      </CookieConsent>

      <div className="main-content">
        <Routes>
          {/* Standard sider */}
          <Route path="/" element={<Home />} />
          <Route path="SchoolsAndClubsPage" element={<SchoolsAndClubsPage />} />
          <Route path="Fornyemedlemmer" element={<Fornyemedlemmer />} />
          <Route path="Gametime" element={<TrainingPage />} />
          <Route path="Gamespage" element={<Gamespage />} />
          <Route path="Omos" element={<Omos />} />
          <Route path="login" element={<Login />} />
          <Route path="signup-academy" element={<SignupAcademy />} />
          <Route path="profile-academy" element={<ProfileRouter />} />
          <Route path="admin" element={<AdminDashboard />} />
          <Route path="WebGLMap" element={<WebGLMap />} />
          <Route path="/opening-prices" element={<OpeningPrices />} />

          {/* Policy sider */}
          <Route path="/Terms" element={<TermsPage />} />
          <Route path="/Privatlivspolitik" element={<PrivacyPolicyPage />} />
          <Route path="/Betalingsbetingelser" element={<PaymentTermsPage />} />

          {/* Fallback */}
          <Route path="*" element={<Home />} />
        </Routes>
      </div>

      <Footer />
    </Router>
  );
}

export default App;